import { EMAIL_VALIDATION_REGEX } from '@/constants';
import { PASSWORD_RULES } from '@/features/auth/constants';

export const isValidPassword = (password: string): boolean => {
  return PASSWORD_RULES.every((rule) => rule.test(password));
};

export const isValidEmail = (email: string): boolean => {
  return EMAIL_VALIDATION_REGEX.test(email);
};
